/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Local_Show_In_FolderInputs */



/**
* | output |
* | --- |
* | "Show in folder" |
*
* @param {Embed_Captions_Local_Show_In_FolderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_show_in_folder = /** @type {((inputs?: Embed_Captions_Local_Show_In_FolderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Show_In_FolderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher dans le dossier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Im Ordner anzeigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra nella cartella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Показать в папке")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar en la carpeta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在文件夹中显示")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォルダーに表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ोल्डर में दिखाओ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mostrar na pasta")
	return /** @type {LocalizedString} */ ("Show in folder")
});